import React from "react";

function LeaveRequestForm() {
  return (
    <div>
      <h1>Leave Request Form</h1>
      <p>This page is working!</p>
    </div>
  );
}

export default LeaveRequestForm;
